import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidatorPatterns } from '@shared/validatorpatterns';
import { ITeamProfile, ITeamProfileConfiguration, ITimeInterval, IWeekDays, IWorkDay } from '../teamProfiles.service';
import { objectValidator, ObjectValidators, ValidatorMap } from './objectValidator';

const timePattern = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/; // HH:MM:SS
const datePattern = /^\d{4}-(1[0-2]|0[1-9])-\d{2}$/; // YYYY-MM-DD

@Injectable({ providedIn: 'root' })
export class MesTeamProfileValidationService {
	constructor(private translator: TranslateService) {}

	validators(ValidateId: boolean = true): ValidatorMap<ITeamProfile> {
		const timeInterval: ValidatorMap<ITimeInterval> = {
			startTime: [ObjectValidators.required, ObjectValidators.pattern(timePattern, 'mes.administration.team-profiles.validation.configurations.weekDays.workTime.time-format-error')],
			endTime: [ObjectValidators.required, ObjectValidators.pattern(timePattern, 'mes.administration.team-profiles.validation.configurations.weekDays.workTime.time-format-error')],
		};

		const workDay: ValidatorMap<IWorkDay> = {
			isWorkDay: [ObjectValidators.required],
			workTime: [ObjectValidators.required],
			variableWeeklyWorkTime: [],
			breaks: [ObjectValidators.array([ObjectValidators.required, ObjectValidators.object(timeInterval)])],
		};

		const weekDays: ValidatorMap<IWeekDays> = {
			monday: [ObjectValidators.required, ObjectValidators.object(workDay)],
			tuesday: [ObjectValidators.required, ObjectValidators.object(workDay)],
			wednesday: [ObjectValidators.required, ObjectValidators.object(workDay)],
			thursday: [ObjectValidators.required, ObjectValidators.object(workDay)],
			friday: [ObjectValidators.required, ObjectValidators.object(workDay)],
			saturday: [ObjectValidators.required, ObjectValidators.object(workDay)],
			sunday: [ObjectValidators.required, ObjectValidators.object(workDay)],
		};

		const teamProfileConfigValidator: ValidatorMap<ITeamProfileConfiguration> = {
			alias: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Alias, 'mes.administration.team-profiles.dialog.config-alias.error.pattern', true)],
			activeDate: [ObjectValidators.required, ObjectValidators.pattern(datePattern, 'mes.administration.team-profiles.validation.configurations.active-date.time-format-error')],
			weekDays: [ObjectValidators.required, ObjectValidators.object(weekDays)],
			roundingTime: [ObjectValidators.required],
			endRoundingTime: [ObjectValidators.required],
		};

		const validator: ValidatorMap<ITeamProfile> = {
			id: [ObjectValidators.required],
			alias: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Alias, 'mes.administration.team-profiles.dialog.alias.error.pattern', true)],
			description: [ObjectValidators.required, ObjectValidators.maxLength(255), ObjectValidators.pattern(ValidatorPatterns.Alias, 'mes.administration.team-profiles.dialog.description.error.pattern', true)],
			calendarId: [ObjectValidators.required],
			timeZoneId: [ObjectValidators.required],
			configurations: [ObjectValidators.required, ObjectValidators.notEmpty, ObjectValidators.array([ObjectValidators.required, ObjectValidators.object(teamProfileConfigValidator)])],
		};

		if (!ValidateId) {
			delete validator.id;
		}

		return validator;
	}

	validateTeamProfile(user: ITeamProfile, ValidateId: boolean = true): Record<string, ValidationErrors> {
		return objectValidator.validateObject(user, this.validators(ValidateId), this.translator);
	}
}
